import { getRequest } from '../../services/api';
import type { ApiResponse } from '../../services/types';

import type { FeatureManagerData } from './types';

export async function fetchOrder() {
  const response =
    await getRequest<ApiResponse<{ featureManagerOrderConfigurations: FeatureManagerData }>>('/v2/ui/features/config');
  return response.data.data?.featureManagerOrderConfigurations;
}

export type RetryWithTimeoutArgs = {
  reCheck: () => boolean;
  onTimeout: () => void;
  intervalMs: number;
  maxRetries: number;
};

export function recheckWithTimeout({ intervalMs, onTimeout, reCheck, maxRetries }: RetryWithTimeoutArgs) {
  let retries = 0;
  const interval = setInterval(() => {
    if (reCheck()) {
      clearInterval(interval);
      return;
    }
    retries++;
    if (retries >= maxRetries) {
      clearInterval(interval);
      onTimeout();
      return;
    }
  }, intervalMs);
}
